<template>
<div class="chapter">
<div class="inner_page">
<h3 class="calibre4">Widmung an Marie Thienemann</h3>
<p class="center">In einer Handschrift des Dramas »Germanen und
Römer«</p>
<p class="vers">Blumen blühen in dem Garten<br class="calibre2"/>
meines Geistes, kaum entsprossen,<br class="calibre2"/>
und noch sind die kleinen, zarten<br class="calibre2"/>
Schmetterlinge Spielgenossen.</p>
<p class="vers">Schmetterlinge mögen walten,<br class="calibre2"/>
bis zu mächt'gen Blätterkronen<br class="calibre2"/>
andre Knospen sich gestalten,<br class="calibre2"/>
drin die Nachtigallen wohnen.</p>
<p class="vers">Tief im Grunde keimen Bäume,<br class="calibre2"/>
Wächter in den duft'gen Matten.<br class="calibre2"/>
Blumendüfte geben Träume,<br class="calibre2"/>
Eichenwipfel geben Schatten.</p>
<p class="centersml">1882.</p>
<p class="calibre1"><a class="pcalibre pcalibre3 pcalibre1 pcalibre2" id="page17" title="wedi/Konmax"></a> <a class="pcalibre pcalibre3 pcalibre1 pcalibre2" id="page18" title="wedi/Konmax"></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0004.vue?7f72b2cc